import { CountDateMetricReport } from '@/types/workflow-metric-reports'
import { getLeftMarginForCountChart } from '@/utils/chart'
import TimeCountBarChart from '@/components/charts/TimeCountBarChart'
import { DateRange } from '../ProjectMetricsDashboard'
import { GroupOption } from '@/types/metrics'

type DocumentsCountChartProps = {
  groupedBy: GroupOption
  selectedDateRange: DateRange
  report?: CountDateMetricReport
}

export default function DocumentsCountChart({
  groupedBy,
  selectedDateRange,
  report,
}: DocumentsCountChartProps) {
  const maxYValue = Math.max(
    ...(report?.reports.map((r) => r.formatted_result) || [0]),
  )
  return (
    <TimeCountBarChart
      enableLabel
      height={250}
      from={selectedDateRange.startDate}
      to={selectedDateRange.endDate}
      data={report?.reports || []}
      groupedBy={groupedBy}
      margin={{
        left: getLeftMarginForCountChart(maxYValue),
        right: 20,
      }}
      yKey="formatted_result"
      labelSkipHeight={12}
      labelSkipWidth={20}
    />
  )
}
